import { DatePicker, Empty, Modal, Radio } from '@maxtropy/components';
import {
  apiV2MicrogridOverviewGetProfitAnalysisPost,
  V2MicrogridOverviewGetBsaStrategyListPostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import { useContext, useMemo, useState } from 'react';
import { ResolutionEnum, ResolutionEnumDisplay } from '../type';
import dayjs, { Dayjs } from 'dayjs';
import ReactEcharts from 'echarts-for-react';
import styles from './index.module.scss';
import { getChartOption } from './chart';
import { useRequest } from 'ahooks';
import { Spin } from 'antd';
import { ShareDataContext } from '..';
import { keepTwoOrLine } from '../utils';

interface AddUnitModalProps {
  id?: number;
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export type BsaItem = Exclude<V2MicrogridOverviewGetBsaStrategyListPostResponse['list'], undefined>[number];

const IncomeAnalysisModal: React.FC<AddUnitModalProps> = ({ id, visible, setVisible }) => {
  const [resolution, setResolution] = useState<ResolutionEnum>(ResolutionEnum.DAY);
  const [date, setDate] = useState<Dayjs>(dayjs());
  const { microgridId } = useContext(ShareDataContext);

  // 图表数据
  const { data, loading } = useRequest(
    () => {
      return apiV2MicrogridOverviewGetProfitAnalysisPost({
        id: microgridId,
        startTime: resolution === ResolutionEnum.DAY ? date.startOf('day').valueOf() : date.startOf('month').valueOf(),
        endTime: resolution === ResolutionEnum.DAY ? date.endOf('day').valueOf() : date.endOf('month').valueOf(),
        timeResolution: resolution,
      });
    },
    {
      ready: !!microgridId && visible && !!date,
      refreshDeps: [microgridId, visible, date, resolution],
    }
  );

  // 查询图表
  const chartOption = useMemo(() => getChartOption(data?.detail), [data]);

  return (
    <Modal
      open={visible}
      title="收益分析"
      size="big"
      onOk={() => {
        console.log('ok');
      }}
      getContainer={() => document.getElementById('full_screen_box') ?? document.body}
      onCancel={() => {
        setVisible(false);
      }}
    >
      <Radio.Group
        buttonStyle="solid"
        value={resolution}
        onChange={e => {
          setResolution(e.target.value);
        }}
      >
        <Radio.Button value={ResolutionEnum.DAY}>{ResolutionEnumDisplay[ResolutionEnum.DAY]}</Radio.Button>
        <Radio.Button value={ResolutionEnum.MONTH}>{ResolutionEnumDisplay[ResolutionEnum.MONTH]}</Radio.Button>
      </Radio.Group>
      <DatePicker
        style={{ width: 240, marginLeft: 8 }}
        allowClear={false}
        picker={resolution === ResolutionEnum.DAY ? 'date' : 'month'}
        value={date}
        onChange={date => setDate(date)}
        disabledDate={current => {
          return current > dayjs()
        }}
        getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
      />
      <div className={styles.dataBoxContainer}>
        {resolution === ResolutionEnum.DAY && (
          <>
            <div className={styles.dataBox}>
              <div>昨日收益</div>
              <div className={styles.centerLine}></div>
              <div>{keepTwoOrLine(data?.lastValue)}元</div>
            </div>
            <div className={styles.dataBox}>
              <div>本日收益</div>
              <div className={styles.centerLine}></div>
              <div>{keepTwoOrLine(data?.currentValue)}元</div>
            </div>
          </>
        )}
        {resolution === ResolutionEnum.MONTH && (
          <>
            <div className={styles.dataBox}>
              <div>上月收益</div>
              <div className={styles.centerLine}></div>
              <div>{keepTwoOrLine(data?.lastValue)}元</div>
            </div>
            <div className={styles.dataBox}>
              <div>本月收益</div>
              <div className={styles.centerLine}></div>
              <div>{keepTwoOrLine(data?.currentValue)}元</div>
            </div>
          </>
        )}
      </div>
      <Spin spinning={loading}>
        {!data?.detail || data?.detail.length === 0 ? (
          <Empty style={{ margin: '160px 0' }} />
        ) : (
          <ReactEcharts style={{ width: 960, height: 400 }} option={chartOption} notMerge lazyUpdate={false} />
        )}
      </Spin>
    </Modal>
  );
};

export default IncomeAnalysisModal;
